/**
 * Substituto runtime do antigo VITE_CUSTOM_BUILD: true quando o bundle do AC
 * (window.__APP_BRAND__ = 'ac', inline script no index.html do AC) roda no
 * domínio da Consumidor Positivo (experiência injetada via CloudFront Function).
 * Libs compartilhadas também rodam no app CP (newco) — o guard de marca evita
 * falso positivo lá. Localhost sempre resolve false (modo CP só testável em
 * stg/homolog).
 */
export const isAcOnCpHost = (): boolean =>
  typeof window !== 'undefined' &&
  (window as Window & { __APP_BRAND__?: string }).__APP_BRAND__ === 'ac' &&
  window.location.hostname.endsWith('consumidorpositivo.com.br');
